import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import { Section } from './ui/Section';
const faqs = [{
  q: '¿El material está realmente alineado al EBI vigente?',
  a: 'Sí. Todo el material fue desarrollado tomando como base el Programa de Educación Básica Integrada vigente específicamente para el Tramo 2. Las planificaciones · secuencias didácticas y evaluaciones responden a los descriptores · orientaciones y unidades curriculares oficiales de ANEP.'
}, {
  q: '¿Qué pasa si mi grupo tiene distintos niveles de logro?',
  a: 'Cada tomo incluye actividades diferenciadas por nivel de logro (LI · LP · LE · LD). Podés usar la misma ficha con distintos niveles de exigencia sin armar material adicional para cada grupo.'
}, {
  q: '¿Puedo usar el material en 3° y en 4° al mismo tiempo?',
  a: 'Sí. Los tomos están diseñados para el Tramo 2 completo (3° y 4° de escuela). Podés ajustar el nivel de demanda de las fichas según el año que estés trabajando.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Una vez que realizás el pago a través de Mercado Pago recibís el acceso por email en menos de 5 minutos. Son archivos PDF listos para descargar · guardar e imprimir. Podés usarlos desde cualquier dispositivo.'
}, {
  q: '¿Y si ya tengo material propio de estas áreas?',
  a: 'Aula de Éxitos™ complementa lo que ya tenés. No reemplaza tu práctica docente. Te libera del tiempo que perdés armando lo que ya existe.'
}, {
  q: '¿Puedo compartirlo con colegas?',
  a: 'El material es de uso personal e intransferible. Cada docente necesita su propia licencia. Si querés recomendarlo a una colega ¡genial! Podés compartirle el link de la tienda.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section background="cream" data-id="element-57">
      <div className="max-w-3xl mx-auto" data-id="element-58">
        <div className="text-center mb-12" data-id="element-59">
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900" data-id="element-60">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-61">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl shadow-sm border border-stone-200 overflow-hidden" data-id="element-62">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-celeste-500" aria-expanded={openIndex === idx} data-id="element-63">
                <span className="font-bold text-stone-800 pr-4" data-id="element-64">{faq.q}</span>
                <span className="text-celeste-600 shrink-0" data-id="element-65">
                  {openIndex === idx ? <Minus className="w-5 h-5" data-id="element-66" /> : <Plus className="w-5 h-5" data-id="element-67" />}
                </span>
              </button>

              <AnimatePresence data-id="element-68">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-69">
                    <div className="px-6 pb-5 text-stone-600 font-medium leading-relaxed border-t border-stone-50 pt-4" data-id="element-70">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
};